module.exports = __webpack_public_path__ + "static/img/13@2x.3a989fc7.png";